function ProductModel(BaseModel) {
    'ngInject';

    class Product extends BaseModel {
    }

    return Product;
}

angular
    .module('BB')
    .service('ProductModel', ProductModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/product_model.service.js